import React, { useState } from 'react';
import { StoreIcon, TrendingUpIcon, AwardIcon, MoreVerticalIcon, StarIcon, XIcon, MapPinIcon, PhoneIcon, MailIcon, ClockIcon, BanknoteIcon, SettingsIcon, PlusIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useMavisData, formatZAR } from '../hooks/useMavisData';
export function Vendors() {
  const data = useMavisData();
  const [selectedVendorId, setSelectedVendorId] = useState<string | null>(null);
  const selectedVendor = data.vendors.find(v => v.id === selectedVendorId);
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-2949">
      <div className="mb-8 flex justify-between items-start" data-id="element-2950">
        <div data-id="element-2951">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2952">
            Vendor Management
          </h1>
          <p className="text-gray-500" data-id="element-2953">
            Monitor community vendors, sales performance, and commissions.
          </p>
        </div>
        <Link to="/vendors/add" className="inline-flex items-center gap-2 px-4 py-2.5 bg-mavis-teal text-white font-medium rounded-none hover:bg-mavis-teal/90 transition-colors shadow-sm text-sm" data-id="element-2954">

          <PlusIcon className="w-4 h-4" data-id="element-2955" />
          Add Vendor
        </Link>
      </div>

      {/* Top Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2956">
        <div className="bg-gradient-to-br from-mavis-teal to-[#1a6a7a] rounded-none p-6 text-white shadow-md bg-[#003A4D]" data-id="element-2957">
          <div className="flex justify-between items-start mb-4" data-id="element-2958">
            <div data-id="element-2959">
              <p className="text-teal-100 text-sm font-medium mb-1" data-id="element-2960">
                Total Active Vendors
              </p>
              <h3 className="text-3xl font-bold font-mono" data-id="element-2961">142</h3>
            </div>
            <div className="p-3 bg-white/10 rounded-none" data-id="element-2962">
              <StoreIcon className="w-6 h-6 text-white" data-id="element-2963" />
            </div>
          </div>
          <p className="text-sm text-teal-100 flex items-center gap-1" data-id="element-2964">
            <TrendingUpIcon className="w-4 h-4" data-id="element-2965" /> +5 new this month
          </p>
        </div>

        <div className="bg-white rounded-none p-6 border border-gray-200 shadow-sm" data-id="element-2966">
          <div className="flex justify-between items-start mb-4" data-id="element-2967">
            <div data-id="element-2968">
              <p className="text-gray-500 text-sm font-medium mb-1" data-id="element-2969">
                Total Sales (Today)
              </p>
              <h3 className="text-3xl font-bold text-gray-900 font-mono" data-id="element-2970">
                {formatZAR(145800)}
              </h3>
            </div>
            <div className="p-3 bg-mavis-blue/10 rounded-none" data-id="element-2971">
              <TrendingUpIcon className="w-6 h-6 text-mavis-blue" data-id="element-2972" />
            </div>
          </div>
          <p className="text-sm text-mavis-green font-medium flex items-center gap-1" data-id="element-2973">
            +12.5% vs yesterday
          </p>
        </div>

        <div className="bg-white rounded-none p-6 border border-gray-200 shadow-sm" data-id="element-2974">
          <div className="flex justify-between items-start mb-4" data-id="element-2975">
            <div data-id="element-2976">
              <p className="text-gray-500 text-sm font-medium mb-1" data-id="element-2977">
                Commissions Paid (MTD)
              </p>
              <h3 className="text-3xl font-bold text-gray-900 font-mono" data-id="element-2978">
                {formatZAR(42500)}
              </h3>
            </div>
            <div className="p-3 bg-mavis-gold/10 rounded-none" data-id="element-2979">
              <AwardIcon className="w-6 h-6 text-mavis-gold" data-id="element-2980" />
            </div>
          </div>
          <p className="text-sm text-gray-500" data-id="element-2981">Average 5% commission rate</p>
        </div>
      </div>

      {/* Vendor Table */}
      <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-2982">
        <div className="p-6 border-b border-gray-200 flex justify-between items-center bg-gray-50/50" data-id="element-2983">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-2984">
            Vendor Performance
          </h2>
          <button className="text-sm font-medium text-mavis-teal hover:underline" data-id="element-2985">
            Export CSV
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-2986">
          <table className="w-full text-left border-collapse" data-id="element-2987">
            <thead data-id="element-2988">
              <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-2989">
                <th className="p-4 font-medium" data-id="element-2990">Vendor Name</th>
                <th className="p-4 font-medium" data-id="element-2991">Location</th>
                <th className="p-4 font-medium text-right" data-id="element-2992">Sales (Today)</th>
                <th className="p-4 font-medium text-right" data-id="element-2993">Commission</th>
                <th className="p-4 font-medium text-center" data-id="element-2994">Rating</th>
                <th className="p-4 font-medium" data-id="element-2995">Status</th>
                <th className="p-4 font-medium" data-id="element-2996"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-2997">
              {data.vendors.map(vendor => <tr key={vendor.id} onClick={() => setSelectedVendorId(vendor.id)} className="hover:bg-gray-50 transition-colors group cursor-pointer" data-id="element-2998">

                  <td className="p-4" data-id="element-2999">
                    <div className="flex items-center gap-3" data-id="element-3000">
                      <div className="w-10 h-10 rounded-none bg-gray-100 flex items-center justify-center text-gray-500 font-bold" data-id="element-3001">
                        {vendor.name.charAt(0)}
                      </div>
                      <div data-id="element-3002">
                        <p className="font-medium text-gray-900" data-id="element-3003">
                          {vendor.name}
                        </p>
                        <p className="text-xs text-gray-500 font-mono" data-id="element-3004">
                          {vendor.id}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="p-4 text-sm text-gray-600" data-id="element-3005">
                    {vendor.location}
                  </td>
                  <td className="p-4 text-right font-mono font-medium text-gray-900" data-id="element-3006">
                    {formatZAR(vendor.salesToday)}
                  </td>
                  <td className="p-4 text-right font-mono text-mavis-teal font-medium" data-id="element-3007">
                    {formatZAR(vendor.commission)}
                  </td>
                  <td className="p-4" data-id="element-3008">
                    <div className="flex items-center justify-center gap-1" data-id="element-3009">
                      <StarIcon className={`w-4 h-4 ${vendor.rating >= 4 ? 'text-mavis-gold fill-mavis-gold' : 'text-gray-300'}`} data-id="element-3010" />


                      <span className="text-sm font-medium text-gray-700" data-id="element-3011">
                        {vendor.rating}
                      </span>
                    </div>
                  </td>
                  <td className="p-4" data-id="element-3012">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${vendor.status === 'Active' ? 'bg-green-100 text-green-800' : vendor.status === 'Warning' ? 'bg-orange-100 text-orange-800' : 'bg-red-100 text-red-800'}`} data-id="element-3013">

                      {vendor.status}
                    </span>
                  </td>
                  <td className="p-4 text-right" data-id="element-3014">
                    <button className="text-gray-400 hover:text-mavis-teal transition-colors p-1 rounded-none hover:bg-gray-100 opacity-0 group-hover:opacity-100" data-id="element-3015">
                      <MoreVerticalIcon className="w-5 h-5" data-id="element-3016" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Detail Panel Backdrop */}
      {selectedVendorId && <div className="fixed inset-0 bg-black/50 z-40 transition-opacity" onClick={() => setSelectedVendorId(null)} data-id="element-3017" />}

      {/* Detail Panel */}
      <div className={`fixed right-0 top-0 h-full w-full max-w-[450px] bg-white z-50 shadow-2xl border-l border-gray-200 transform transition-transform duration-300 ease-in-out overflow-y-auto ${selectedVendorId ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-3018">

        {selectedVendor && <div className="flex flex-col h-full" data-id="element-3019">
            {/* Header */}
            <div className="p-6 border-b border-gray-100 flex justify-between items-start bg-gray-50" data-id="element-3020">
              <div className="flex items-start gap-4" data-id="element-3021">
                <div className="w-14 h-14 rounded-none text-white flex items-center justify-center text-xl font-bold shadow-sm bg-[#284859]" data-id="element-3022">
                  {selectedVendor.name.charAt(0)}
                </div>
                <div data-id="element-3023">
                  <h2 className="text-xl font-bold text-gray-900 leading-tight" data-id="element-3024">
                    {selectedVendor.name}
                  </h2>
                  <p className="text-sm text-gray-500 font-mono mt-1" data-id="element-3025">
                    {selectedVendor.id}
                  </p>
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium mt-2 ${selectedVendor.status === 'Active' ? 'bg-green-100 text-green-800' : selectedVendor.status === 'Warning' ? 'bg-orange-100 text-orange-800' : 'bg-red-100 text-red-800'}`} data-id="element-3026">

                    {selectedVendor.status}
                  </span>
                </div>
              </div>
              <button onClick={() => setSelectedVendorId(null)} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-200 rounded-none transition-colors" data-id="element-3027">

                <XIcon className="w-6 h-6" data-id="element-3028" />
              </button>
            </div>

            <div className="p-6 space-y-8 flex-1" data-id="element-3029">
              {/* Contact & Location Info */}
              <section data-id="element-3030">
                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-3031">
                  Vendor Details
                </h3>
                <div className="space-y-3" data-id="element-3032">
                  <div className="flex items-start gap-3" data-id="element-3033">
                    <MapPinIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-3034" />
                    <div data-id="element-3035">
                      <p className="text-sm text-gray-500" data-id="element-3036">Location</p>
                      <p className="font-medium text-gray-900" data-id="element-3037">
                        {selectedVendor.location}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-3038">
                    <PhoneIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-3039" />
                    <div data-id="element-3040">
                      <p className="text-sm text-gray-500" data-id="element-3041">Contact Number</p>
                      <p className="font-medium text-gray-900" data-id="element-3042">
                        +27 82 123 4567
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-3043">
                    <MailIcon className="w-5 h-5 text-gray-400 mt-0.5" data-id="element-3044" />
                    <div data-id="element-3045">
                      <p className="text-sm text-gray-500" data-id="element-3046">Email Address</p>
                      <p className="font-medium text-gray-900" data-id="element-3047">
                        contact@
                        {selectedVendor.name.toLowerCase().replace(/\s+/g, '')}
                        .co.za
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Performance Stats */}
              <section className="bg-gray-50 p-5 rounded-none border border-gray-100" data-id="element-3048">
                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4" data-id="element-3049">
                  Today's Performance
                </h3>
                <div className="grid grid-cols-2 gap-4" data-id="element-3050">
                  <div data-id="element-3051">
                    <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-3052">
                      Total Sales
                    </p>
                    <p className="font-mono font-bold text-gray-900 text-xl" data-id="element-3053">
                      {formatZAR(selectedVendor.salesToday)}
                    </p>
                  </div>
                  <div data-id="element-3054">
                    <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-3055">
                      Commission Earned
                    </p>
                    <p className="font-mono font-bold text-mavis-teal text-xl" data-id="element-3056">
                      {formatZAR(selectedVendor.commission)}
                    </p>
                  </div>
                  <div className="col-span-2 pt-4 border-t border-gray-200 mt-2" data-id="element-3057">
                    <div className="flex justify-between items-center" data-id="element-3058">
                      <p className="text-sm text-gray-600" data-id="element-3059">Vendor Rating</p>
                      <div className="flex items-center gap-1" data-id="element-3060">
                        {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className={`w-5 h-5 ${star <= Math.floor(selectedVendor.rating) ? 'text-mavis-gold fill-mavis-gold' : 'text-gray-300'}`} data-id="element-3061" />)}
                        <span className="ml-2 font-medium text-gray-900" data-id="element-3062">
                          {selectedVendor.rating}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Recent Transactions */}
              <section data-id="element-3063">
                <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2" data-id="element-3064">
                  Recent Sales
                </h3>
                <div className="space-y-3" data-id="element-3065">
                  {[{
                amount: 150,
                time: '10 mins ago',
                status: 'Success'
              }, {
                amount: 50,
                time: '1 hour ago',
                status: 'Success'
              }, {
                amount: 200,
                time: '3 hours ago',
                status: 'Success'
              }, {
                amount: 100,
                time: '5 hours ago',
                status: 'Failed'
              }].map((txn, i) => <div key={i} className="flex items-center justify-between p-3 border border-gray-100 rounded-none hover:bg-gray-50 transition-colors" data-id="element-3066">

                      <div className="flex items-center gap-3" data-id="element-3067">
                        <div className={`p-2 rounded-none ${txn.status === 'Success' ? 'bg-green-50 text-mavis-green' : 'bg-red-50 text-red-500'}`} data-id="element-3068">

                          <BanknoteIcon className="w-4 h-4" data-id="element-3069" />
                        </div>
                        <div data-id="element-3070">
                          <p className="font-medium text-gray-900 text-sm" data-id="element-3071">
                            Token Sold
                          </p>
                          <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-3072">
                            <ClockIcon className="w-3 h-3" data-id="element-3073" /> {txn.time}
                          </p>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-3074">
                        <p className="font-mono font-bold text-gray-900" data-id="element-3075">
                          {formatZAR(txn.amount)}
                        </p>
                        <p className={`text-[10px] font-medium uppercase ${txn.status === 'Success' ? 'text-mavis-green' : 'text-red-500'}`} data-id="element-3076">

                          {txn.status}
                        </p>
                      </div>
                    </div>)}
                </div>
                <button className="w-full mt-4 py-2 text-sm text-mavis-teal font-medium hover:bg-mavis-teal/5 rounded-none transition-colors border border-transparent hover:border-mavis-teal/20" data-id="element-3077">
                  View All Transactions
                </button>
              </section>
            </div>

            {/* Quick Actions Footer */}
            <div className="p-6 border-t border-gray-100 bg-gray-50 grid grid-cols-1 gap-3" data-id="element-3078">
              <button className="w-full py-3 bg-mavis-teal text-white font-medium rounded-none hover:bg-mavis-teal/90 transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-3079">
                <StoreIcon className="w-4 h-4" data-id="element-3080" /> View Full Profile
              </button>
              <div className="grid grid-cols-2 gap-3" data-id="element-3081">
                <button className="w-full py-2 bg-white border border-gray-300 text-gray-700 font-medium rounded-none hover:bg-gray-50 transition-colors text-sm shadow-sm flex items-center justify-center gap-2" data-id="element-3082">
                  <SettingsIcon className="w-4 h-4" data-id="element-3083" /> Commission
                </button>
                <button className="w-full py-2 bg-white border border-gray-300 text-gray-700 font-medium rounded-none hover:bg-gray-50 transition-colors text-sm shadow-sm flex items-center justify-center gap-2" data-id="element-3084">
                  <MailIcon className="w-4 h-4" data-id="element-3085" /> Contact
                </button>
              </div>
            </div>
          </div>}
      </div>
    </div>;
}